import type { AppListing } from '@/backend/types';

/**
 * Filter the Discover catalog by a free-text query (name/description/category)
 * and an optional exact category. Case-insensitive, whitespace-trimmed; empty
 * query + no category returns everything (order preserved). Each whitespace-
 * separated term must match (AND), so "water daily" narrows progressively.
 */
export function filterApps(apps: AppListing[], query: string, category?: string | null): AppListing[] {
  const terms = query.toLowerCase().trim().split(/\s+/).filter(Boolean);
  return apps.filter((app) => {
    if (category && app.category !== category) return false;
    if (terms.length === 0) return true;
    const haystack = `${app.name} ${app.description} ${app.category ?? ''}`.toLowerCase();
    return terms.every((t) => haystack.includes(t));
  });
}

/** Apps published by a given creator (order preserved). */
export function appsByCreator(apps: AppListing[], creatorId: string): AppListing[] {
  return apps.filter((a) => a.creatorId === creatorId);
}

/** Distinct, non-empty categories present in the catalog, alphabetically sorted. */
export function listCategories(apps: AppListing[]): string[] {
  const set = new Set<string>();
  for (const app of apps) {
    if (app.category && app.category.trim()) set.add(app.category);
  }
  return [...set].sort();
}
